import { config } from '../config';
import { ApplicationInsightsHttpClient } from '../http/application-insights-http-client';
import { ConsoleLogger } from './console-logger';
import { EnvironmentService } from '../services/environment-service';
import { getUnsafeDateNow } from '../utils/utils';
export class ApplicationInsightsLogger {
    constructor(uiFrameAdapter, sessionId) {
        this.uiFrameAdapter = uiFrameAdapter;
        this.sessionId = sessionId;
        this.timer = null;
        this.messageBuffer = [];
        this.http = new ApplicationInsightsHttpClient('https://dc.services.visualstudio.com', ConsoleLogger.Instance);
        const environmentService = new EnvironmentService(uiFrameAdapter);
        this.appInsightsInstrumentationKey = environmentService.determineEnvironment().then(environment => {
            const urls = config.appInsightsInstrumentationKey;
            return urls[environment];
        });
    }
    logInformation(messageText) {
        const message = this.generateTrace(messageText.toString(), SeverityLevel.Information);
        void message.then(message => this.queue(message));
    }
    logWarning(error) {
        const message = error instanceof (Error) ? this.generateException(error, SeverityLevel.Warning) : this.generateTrace(error.toString(), SeverityLevel.Warning);
        void message.then(message => this.queue(message));
    }
    logError(error) {
        const message = error instanceof (Error) ? this.generateException(error, SeverityLevel.Error) : this.generateTrace(error.toString(), SeverityLevel.Error);
        void message.then(message => this.queue(message));
    }
    startTimer() {
        if (!this.timer) {
            this.timer = setTimeout(() => {
                this.timer = null;
                this.send();
            }, 5000);
        }
    }
    queue(message) {
        this.messageBuffer.push(message);
        this.startTimer();
    }
    send() {
        const messages = this.messageBuffer.splice(0, this.messageBuffer.length);
        this.http.post('v2/track', messages).catch(reason => {
            console.log(`Failed to send log to App Insights reason: ${reason}`);
        });
    }
    async generateTrace(message, severity) {
        return ({
            "time": getUnsafeDateNow(),
            "iKey": await this.appInsightsInstrumentationKey,
            "name": `Microsoft.ApplicationInsights.${(await this.appInsightsInstrumentationKey).replace(/-/g, '')}.Message`,
            "tags": {
                "ai.user.authUserId": this.uiFrameAdapter.userId,
                "ai.session.id": this.sessionId,
                "ai.device.id": "browser",
                "ai.device.type": "Browser",
                "ai.operation.name": "srcdoc",
                "ai.operation.id": this.sessionId,
                "ai.user.accountId": this.uiFrameAdapter.companyId,
                "ai.internal.sdkVersion": "javascript:2.7.1",
                "ai.internal.snippet": "-"
            },
            "data": {
                "baseType": "MessageData",
                "baseData": {
                    "ver": 2,
                    "message": message,
                    "severityLevel": severity,
                    "properties": {
                        "userId": this.uiFrameAdapter.userId,
                        "companyId": this.uiFrameAdapter.companyId,
                        "component": this.uiFrameAdapter.clientComponent,
                        "libVersion": `JavaScript/${config.version}`
                    }
                }
            }
        });
    }
    async generateException(error, severity) {
        return ({
            "time": getUnsafeDateNow(),
            "iKey": await this.appInsightsInstrumentationKey,
            "name": `Microsoft.ApplicationInsights.${(await this.appInsightsInstrumentationKey).replace(/-/g, '')}.Message`,
            "tags": {
                "ai.user.authUserId": this.uiFrameAdapter.userId,
                "ai.session.id": this.sessionId,
                "ai.device.id": "browser",
                "ai.device.type": "Browser",
                "ai.operation.name": "srcdoc",
                "ai.operation.id": this.sessionId,
                "ai.user.accountId": this.uiFrameAdapter.companyId,
                "ai.internal.sdkVersion": "javascript:2.7.1",
                "ai.internal.snippet": "-"
            },
            "data": {
                "baseType": "ExceptionData",
                "baseData": {
                    "ver": 2,
                    "exceptions": [{
                            "typeName": error.name,
                            "message": error.message,
                            "hasFullStack": error.stack !== undefined,
                            "stack": error.stack,
                            "parsedStack": []
                        }],
                    "severityLevel": severity,
                    "properties": {
                        "userId": this.uiFrameAdapter.userId,
                        "companyId": this.uiFrameAdapter.companyId,
                        "component": this.uiFrameAdapter.clientComponent,
                        "libVersion": `JavaScript/${config.version}`
                    }
                }
            }
        });
    }
}
var SeverityLevel;
(function (SeverityLevel) {
    SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
    SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
    SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
    SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
    SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
})(SeverityLevel || (SeverityLevel = {}));
